import { connect } from 'react-redux';

import {
    DEFAULT_NAVIGATION_TABS_STATE,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    NavigationTabsContainer as SourceNavigationTabsContainer
} from 'SourceComponent/NavigationTabs/NavigationTabs.container';

export {
    DEFAULT_NAVIGATION_TABS_STATE
};

/** @namespace PeggysagePwa/Component/NavigationTabs/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
});

/** @namespace PeggysagePwa/Component/NavigationTabs/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
});

/** @namespace PeggysagePwa/Component/NavigationTabs/Container */
export class NavigationTabsContainer extends SourceNavigationTabsContainer {
    /**
     * Overrride: do not show nav tabs when on the bottom
     * @param windowY
     */
    handleNavVisibilityOnScroll(windowY) {
        const ERROR_TOP_OFFSET = 10;
        // const ERROR_BOTTOM_OFFSET = 20;
        const TOP_MIN_OFFSET = 70;

        // const doc = document.body;
        // const offset = window.innerHeight + window.pageYOffset;
        // const height = doc.scrollHeight;

        if (windowY < TOP_MIN_OFFSET) {
            // We are on top
            this.showNavigationTabs();

            return;
        }

        /* if (offset >= (height - ERROR_BOTTOM_OFFSET)) {
            // We are on the bottom
            this.showNavigationTabs();

            return;
        } */

        // Scroll is less then min offset
        if (Math.abs(windowY - this.scrollPosition) < ERROR_TOP_OFFSET) {
            return;
        }

        if (windowY < this.scrollPosition) {
            // Scrolling UP
            this.showNavigationTabs();
        } else {
            // Scrolling DOWN
            this.hideNavigationTabs();
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationTabsContainer);
